import React from 'react';

import classes from './Spinner.scss';

type SpinnerProps = {
    showText?: boolean;
    loadingText?: string;
};

const SpinnerIcon: React.FC<{ className: string }> = ({ className }) => (
    <span className={className} role="status" aria-label="Please Wait..." data-testid="spinner" />
);

export const Spinner: React.FC<SpinnerProps> = ({ showText = true, loadingText }) => {
    return (
        <div className={classes.spinner}>
            <SpinnerIcon className={classes.icon} />
            {showText && <span className={classes.label}>{loadingText ? loadingText : 'Please wait...'}</span>}
        </div>
    );
};

export const StaticSpinner: React.FC = () => {
    return <SpinnerIcon className={classes.staticSpinner} />;
};
